// extracted by mini-css-extract-plugin
module.exports = {"hiring":"Hiring_hiring__3QFM6","hiring__wrapper":"Hiring_hiring__wrapper__56iiN","hiring__steps":"Hiring_hiring__steps__QcNPW","hiring__button":"Hiring_hiring__button__C2rGR"};